(ns frontend.ui.component.lp-portal.modal.edit-modals.edit-chart-modal
  (:require
   [clojure.data :as data]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.tenant-customizations :as tenant-customizations]
   [frontend.ui.component.lp-portal.modal.edit-modals.common :as common-components]
   [frontend.ui.component.lp-portal.modal.edit-modals.events :as chart-editor-events]
   [frontend.ui.component.lp-portal.modal.edit-modals.invest-europe.chart-data-editor :as invest-europe-chart]
   [frontend.ui.component.lp-portal.modal.style :as style]
   [frontend.ui.component.modal-dialog.style :as modal-style]
   [frontend.ui.component.modal-dialog.view :as modal-dialog]
   [herb.core :as h]
   [reagent.core :as r]
   [ui.color :as c]
   [ui.components.button.view :as button]
   [ui.editors.data-input :as data-input]))

(defn table-color-row
  [state no-columns?]
  [:thead
   (into
    [:tr]
    (concat (when-not no-columns?
              [[:th
                {:class (h/<class style/th)}
                (loc/tr :colors)]])
            (->> @state
                 :series-colors
                 (map-indexed
                  (fn [idx col]
                    ^{:key (str idx "/" (count (:series-colors @state)))}
                    [:th
                     {:class (h/<class style/table-header-cell-container)}
                     [:div
                      {:class (h/<class style/table-header-cell)
                       :id    "header-cell"}
                      [data-input/view
                       {:data-type :data.type/text-simple
                        :class     (h/<class style/table-header-input false)
                        :value     (str col)
                        :on-change  #(chart-editor-events/update-color! state idx %)}]]])))))])

(defn axis-config-row
  [state row-idx row-data]
  (->> row-data
       (map-indexed
        (fn [col-idx col]
          [:<>
           [:td
            {:class (h/<class style/axis-table-cell)}
            (cond (= col-idx 0)
                  [data-input/view
                   {:data-type :data.type/text-simple
                    :class     (h/<class style/table-header-input false)
                    :value     (str col)
                    :on-change  #(chart-editor-events/update-axis-config!
                                 state
                                 row-idx
                                 col-idx
                                 %)
                    :disabled? false}]
                  (= col-idx 2)
                  [data-input/view
                   {:data-type :data.type/ref-single
                    :class     (h/join (h/<class style/number-input)
                                       (h/<class style/full-width))
                    :options   common-components/multiplier-options
                    :value     (->> common-components/multiplier-options
                                    (cu/filter-by :value col)
                                    (first))
                    :on-change (fn [value]
                                 (chart-editor-events/update-axis-config!
                                  state
                                  row-idx
                                  col-idx
                                  value))}]
                  (= col-idx (- (count row-data) 1))
                  [data-input/view
                   {:data-type :data.type/text-simple
                    :class     (h/<class style/table-header-input false)
                    :value     (str col)
                    :on-change  #(chart-editor-events/update-axis-config!
                                 state
                                 row-idx
                                 col-idx
                                 %)
                    :disabled? false}]
                  :else
                  [data-input/view
                   {:data-type    :data.type/number
                    :min-decimals 0
                    :max-decimals 0
                    :class        (h/join (h/<class style/number-input)
                                          (h/<class style/full-width))
                    :value        col
                    :on-change     #(chart-editor-events/update-axis-config!
                                    state
                                    row-idx
                                    col-idx
                                    %)}])]]))))

(defn table-axis-cells-capman
  [state]
  [:table
   [:thead
    (into
     [:tr]
     (concat
      [[:th
        {:class (h/<class style/axis-table-th)}
        [:span
         {:class (h/<class style/title)}
         (loc/tr :y-axis-title)]]]
      [[:th
        {:class (h/<class style/axis-table-th)}
        [:span
         {:class (h/<class style/title)}
         (loc/tr :decimal-amount)]]]
      [[:th
        {:class (h/<class style/axis-table-th)}
        [:span
         {:class (h/<class style/title)}
         (loc/tr :multiplier)]]]
      [[:th
        {:class (h/<class style/axis-table-th)}
        [:span
         {:class (h/<class style/title)}
         (loc/tr :suffix)]]]))]
   (into [:tbody]
         (->> @state
              :y-axis-config
              (map-indexed
               (fn [row-idx row-data]
                 (into [:tr]
                       (axis-config-row state row-idx row-data))))))])

(defn tooltip-config-row
  [state row-idx row-data]
  (->> row-data
       (map-indexed
        (fn [col-idx col]
          [:<>
           [:td
            {:class (h/<class style/axis-table-cell)}
            (cond
              (= col-idx 1)
              [data-input/view
               {:data-type :data.type/ref-single
                :class     (h/join (h/<class style/number-input)
                                   (h/<class style/full-width))
                :options   common-components/multiplier-options
                :value     (->> common-components/multiplier-options
                                (cu/filter-by :value col)
                                (first))
                :on-change (fn [value]
                             (chart-editor-events/update-tooltip-config!
                              state
                              row-idx
                              col-idx
                              value))}]
              (= col-idx (- (count row-data) 1))
              [data-input/view
               {:data-type :data.type/text-simple
                :class     (h/<class style/table-header-input false)
                :value     (str col)
                :on-change  #(chart-editor-events/update-tooltip-config!
                             state
                             row-idx
                             col-idx
                             %)
                :disabled? false}]
              :else
              [data-input/view
               {:data-type    :data.type/number
                :min-decimals 0
                :max-decimals 0
                :class        (h/join (h/<class style/number-input)
                                      (h/<class style/full-width))
                :value        col
                :on-change     #(chart-editor-events/update-tooltip-config!
                                state
                                row-idx
                                col-idx
                                %)}])]]))))

(defn table-tooltip-cells-capman
  [state]
  (let [series-names (map first (:data @state))]            ; Assuming series names are the first elements in each subvector of :data
    [:table
     [:thead
      (into
       [:tr]
       (concat
        [[:th
          {:class (h/<class style/axis-table-th)}
          [:span
           {:class (h/<class style/title)}
           (loc/tr :series-name)]]]
        [[:th
          {:class (h/<class style/axis-table-th)}
          [:span
           {:class (h/<class style/title)}
           (loc/tr :decimal-amount)]]]
        [[:th
          {:class (h/<class style/axis-table-th)}
          [:span
           {:class (h/<class style/title)}
           (loc/tr :multiplier)]]]
        [[:th
          {:class (h/<class style/axis-table-th)}
          [:span
           {:class (h/<class style/title)}
           (loc/tr :suffix)]]]))]
     (into [:tbody]
           (->> @state
                :tooltip-config
                (map-indexed
                 (fn [row-idx row-data]
                   (let [series-name (nth series-names row-idx)] ; Assuming series names align with tooltip-config rows
                     (into [:tr]
                           (conj
                            (tooltip-config-row state row-idx row-data)
                            [:td
                             {:class (h/<class style/table-cell false)}
                             [:span {:class (h/<class style/title)} (or series-name "-")]])))))))]))

(defn table-numerical-body-capman
  [state no-columns?]
  (let [data (:data @state)]
    (when-not no-columns?
      (into [:tbody]
            (->> data
                 (map-indexed
                  (fn [row-idx row-data]
                    (into [:tr]
                          (common-components/numerical-cells-row
                           {:state state
                            :row-idx row-idx
                            :row-data row-data
                            :update-value! chart-editor-events/update-value!})))))))))

(defn data-editor-table-capman
  [{:keys [state no-columns? fixed-columns? fixed-labels? has-colors? donut-chart?]}]
  (if-not (every? (set (keys @state)) #{:data :columns})
    [:div
     (loc/tr :incorrect-chart-data [(pr-str (keys @state))])]
    [:div {:style {:display        "flex"
                   :gap            "20px"
                   :flex-direction "column"}}
     [:h1 (loc/tr :series-data)]
     [:div {:style {:display "flex"
                    :gap     "20px"}}
      [:table
       [common-components/table-header-row state
        {:no-columns?    no-columns?
         :fixed-labels?  fixed-labels?
         :fixed-columns? fixed-columns?
         :has-colors?    has-colors?
         :add-column-to-index! chart-editor-events/add-column-to-index!
         :remove-column! chart-editor-events/remove-column!}]
       [table-numerical-body-capman state no-columns? donut-chart?]
       (when has-colors?
         [table-color-row state no-columns?])]]]))

(defn view
  [{:keys [data]}]
  (let [state (r/atom data)]
    (fn [{:keys [hide! data visible? save! fixed-columns? fixed-labels?]}]
      (let [capman? (tenant-customizations/capman?)
            no-columns? (->> @state
                             :columns
                             (count)
                             (= 0))
            no-changes? (let [[removed added _] (data/diff data @state)]
                          (and (empty? removed)
                               (empty? added)))
            has-colors? (->> @state
                             :series-colors
                             (not-empty))]
        [modal-dialog/modal-dialog
         {:hide!        hide!
          :visible?     visible?
          :size         :xl
          :header-label (loc/tr :edit-chart-data)
          :font-family  "Muli, sans-serif"
          :style        {:body {:margin-right "16px"}}}
         ;;Editor tables separated due to Capman using a different data model in old templates
         (if (and capman?
                  (not (every? (set (keys @state)) #{:y-axis-configs :series :columns})))
           [data-editor-table-capman
            {:state state
             :no-columns?    no-columns?
             :fixed-labels?  fixed-labels?
             :fixed-columns? fixed-columns?
             :has-colors?    has-colors?}]
           [invest-europe-chart/data-editor-table
            {:state state
             :no-columns?    no-columns?
             :fixed-labels?  fixed-labels?
             :fixed-columns? fixed-columns?}])
         [:<>
          [:div
           {:class (h/<class modal-style/footer-left-container)}
           [button/primary-solid
            {:on-click  (fn []
                          (save! @state))
             :disabled? no-changes?}
            (loc/tr :save)]]

          [:div
           {:class (h/<class modal-style/footer-right-container)}
           [button/secondary-hollow
            {:color    ::c/secondary
             :on-click hide!}
            (loc/tr :cancel)]]]]))))

(defn config-editor-view
  [{:keys [data]}]
  (let [state (r/atom data)]
    (fn [{:keys [hide! data visible? save!]}]
      (let [no-changes? (let [[removed added _] (data/diff data @state)]
                          (and (empty? removed)
                               (empty? added)))
            capman? (tenant-customizations/capman?)
            invest-europe-data-model? (every? (set (keys @state)) #{:columns :series :y-axis-configs})]
        [modal-dialog/modal-dialog
         {:hide!        hide!
          :visible?     visible?
          :size         :xl
          :header-label (loc/tr :edit-chart-data)
          :font-family  "Muli, sans-serif"
          :style        {:body {:margin-right "16px"}}}
         (if-not (some (set (keys @state)) #{:y-axis-config :y-axis-configs :tooltip-config})
           [:div
            (loc/tr :incorrect-chart-data [(pr-str (keys @state))])]
           [:div {:style {:display        "flex"
                          :gap            "20px"
                          :flex-direction "column"}}
            [:h1
             {:style {:font-size "1.2em"}}
             (loc/tr :y-axis-configuration)]
            [:div
             (if (and capman?
                      (not invest-europe-data-model?))
               [table-axis-cells-capman state]
               [invest-europe-chart/table-axis-cells state])]
            (when (or (:series @state) (and capman? (:tooltip-config @state))) ;;TODO refactor
              [:div {:style {:display        "flex"
                             :gap            "20px"
                             :flex-direction "column"}}
               [:h1
                {:style {:font-size "1.2em"}}
                (if capman?
                  (loc/tr :series-tooltip-configuration) 
                  (loc/tr :series-configuration))]
               [:table
                (if (and capman?
                         (not invest-europe-data-model?))
                  [table-tooltip-cells-capman state]
                  [invest-europe-chart/table-tooltip-cells state])]])])
         [:<>
          [:div
           {:class (h/<class modal-style/footer-left-container)}
           [button/primary-solid
            {:on-click  (fn []
                          (save! @state))
             :disabled? no-changes?}
            (loc/tr :save)]]

          [:div
           {:class (h/<class modal-style/footer-right-container)}
           [button/secondary-hollow
            {:on-click hide!}
            (loc/tr :cancel)]]]]))))
